/* MUNDO FUNGI · Bloques del Pack Melena de León. Idempotente: se puede cargar varias veces. */
(function () {
  'use strict';
  if (window.__mfpkInit) return; window.__mfpkInit = true;
  var IO = 'IntersectionObserver' in window;

  function init() {
    // Videos: se cargan al acercarse y se pausan fuera de pantalla
    var vids = [].slice.call(document.querySelectorAll('.mfpk video[data-src]'));
    var SM = window.matchMedia && window.matchMedia('(max-width: 759px)').matches;
    function hydrate(v) { if (v.__ok) return; v.__ok = true; v.src = (SM && v.getAttribute('data-src-sm')) || v.getAttribute('data-src'); v.load(); }
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (IO) {
      var near = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) hydrate(e.target); }); }, { rootMargin: '600px 0px' });
      var vis = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { hydrate(e.target); play(e.target); } else e.target.pause(); }); }, { threshold: 0.15 });
      vids.forEach(function (v) { near.observe(v); vis.observe(v); });
    } else vids.forEach(function (v) { hydrate(v); play(v); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      vids.forEach(function (v) { var r = v.getBoundingClientRect(); if (v.__ok && r.bottom > 0 && r.top < innerHeight) play(v); });
    });

    // Apariciones
    var els = document.querySelectorAll('.mfpk .mfpk-reveal, .mfpk .mfpk-anno-item, .mfpk .mfpk-timeline');
    if (IO) {
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mfpk-in'); ro.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      [].forEach.call(els, function (el) { ro.observe(el); });
    } else [].forEach.call(els, function (el) { el.classList.add('mfpk-in'); });

    // Puntos del carrusel de tarjetas (móvil)
    [].forEach.call(document.querySelectorAll('.mfpk-glass-row'), function (row) {
      var dots = row.parentNode.querySelectorAll('.mfpk-dots i'); if (!dots.length) return;
      var t; row.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(function () {
          var cards = row.querySelectorAll('.mfpk-glass'), w = cards[0].getBoundingClientRect().width + 10;
          var i = Math.min(dots.length - 1, Math.round(row.scrollLeft / w));
          [].forEach.call(dots, function (d, k) { d.classList.toggle('mfpk-on', k === i); });
        }, 60);
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
